/**
 * Company API service for fetching company data.
 * Uses existing apiRequest utility from utils/apiClient.ts
 */

import { apiRequest } from '../utils/apiClient';
import type { TeamResponse, CompanyDashboard, CompanySettings } from '../types/company';

/**
 * Fetch team members and usage stats for the current user's company.
 * Endpoint: GET /companies/my/team
 */
export async function fetchMyTeam(token: string): Promise<TeamResponse> {
  return apiRequest<TeamResponse>('/companies/my/team', {
    method: 'GET',
    token,
  });
}

/**
 * Fetch dashboard stats for the current user's company.
 * Endpoint: GET /companies/my/dashboard
 */
export async function fetchMyDashboard(token: string): Promise<CompanyDashboard> {
  return apiRequest<CompanyDashboard>('/companies/my/dashboard', {
    method: 'GET',
    token,
  });
}

/**
 * Fetch company settings.
 * Endpoint: GET /companies/my/settings
 */
export async function fetchMySettings(token: string): Promise<CompanySettings> {
  return apiRequest<CompanySettings>('/companies/my/settings', {
    method: 'GET',
    token,
  });
}
